/* eslint-disable prefer-rest-params */

function joinUrlPath(array) {
  // concatenate the url with the '.' seperator
  return array.join('.')
  // reduce any duplicated periods '..' to one '.'
  .replace(/(\.){2,}/g, '.')
  // reduce any duplicated slash after a period './///' to one slash '/'
  .replace(/(\.(\/)+)/g, '/');
}

/**
 * Concatenate series of arguments into a valid URL.\
 *
 * This is originally used for SEO purposes, to help splits the Ford host literal string
 * into pieces, it helps avoid Google crawling and intepreting said string as actual link
 * from AT/KBB to Ford site.
 * @param  {String} protocol The HTTP or HTTPS protocol
 * @param  {Array} args Array of url segments
 */
export function seoJoinSplitUrl(protocol) {
  var _protocol;
  if (protocol === void 0) {
    protocol = '';
  }
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  // check args length
  // will not concatenate if provided only 1 string arg
  if (arguments.length >= 1 && args.length >= 1) {
    // check if first argument is a protocol
    // if it is, join the first part without the '.' seperator
    if (/^(http(s)*\b(:\/\/)*)$/.test(protocol)) {
      return (protocol.endsWith('://') ? protocol : protocol.concat('://')).concat(joinUrlPath(args));
    }
    return joinUrlPath(Array.prototype.slice.call(arguments));
  }
  // return the original string if there's only 1 provided
  return (_protocol = protocol) != null ? _protocol : '';
}
export default {
  seoJoinSplitUrl: seoJoinSplitUrl
};